export const environment = {
  name: 'test-us1',
  production: true,
  apiClientId: '1figl9esr3uol2hgdjf7cqkr3g',
  userPoolId: 'us-east-1_hEgntEYMx',
  graphqlEndpoint:
    'https://xldyrzznlnc3nfptgcfro5sski.appsync-api.us-east-1.amazonaws.com/graphql',
  graphqlApiKey: 'da2-s7juqx6lyrb4phulceqdyvxah4',
}
